import script from "./medal.vue?vue&type=script&setup=true&lang=js"
export * from "./medal.vue?vue&type=script&setup=true&lang=js"

import "./medal.vue?vue&type=style&index=0&id=51bd29cb&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bd29cb"]])

export default __exports__